import { render, staticRenderFns } from "./itemcustomergroup.vue?vue&type=template&id=5716eb70"
import script from "./itemcustomergroup.vue?vue&type=script&lang=js"
export * from "./itemcustomergroup.vue?vue&type=script&lang=js"
import style0 from "./itemcustomergroup.vue?vue&type=style&index=0&id=5716eb70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports